// Layout.js
import React from "react";
import { Outlet } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

function Layout() {
  return (
    <>
      <a
        href="#content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-brand-gold focus:text-black focus:rounded-md focus:font-bold"
      >
        Skip to content
      </a>
      <Navigation />
      <main
        id="content"
        className="relative z-10 min-h-screen text-gray-800 dark:text-brand-cream"
      >
        <div className="relative">
          <Outlet />
        </div>
      </main>
      <Footer />
    </>
  );
}

export default Layout;
